export interface Estate {
  fees?: any[];

  totalRevocationAmount?: number;
  totalInvestedAmount?: number;
  totalInitialAmount?: number;
  performanceCalculationBasis?: number;
  totalCurrentMarketPrice?: number;
  ratioRent?: number;
  ratioRentNet?: number;
  performencePercentage?: number;
  currentCapitalLeftOver?: number;
  capitalGain?: number;
  fiscalCapitalGain?: number;
  capitalGainTax?: number;
  actualCost?: number;
  rentGains?: RentGains;
  exceptionalFees?: [];
  regularFees?: [];
  loans?: EstateLoan;
  dismemberDurationLeftAvg?: number;
  dismemberKeyAvg?: number;
  dismemberFinishRent?: number;
  rents?: EstateRents;
  firstRentDate?: string;
  realestate?: RealEstate;
  rentManagement?: {
    tenants: [];
  };
  loan?: boolean;
  totalLoanPaid?: number;
}

export interface RealEstate {
  dismemberKey?: number;
  dismemberDuration?: number;
  isNewProperty?: boolean;
  realEstateType?: string;
  taxSystem?: string;
  label?: string;
  owner?: string;
  ownershipType?: string;
  currentOwnershipType?: string;
  lastValueRealEstate?: number;
  investmentId?: number;
  subscriptionId?: number;
  startDate?: number;
  startDateIsInterp?: boolean;
  endDate?: string;
  closeAmount?: number;
  initialAmount?: number;
  status?: string;
  subLabel?: string;
  lastEstimation?: {
    id?: number;
    source?: string;
    date?: number;
    amount?: number;
    performance?: number;
  };
  lastValue?: number;
  variation?: number;
  isCurrent?: boolean;
  id?: number;
  property?: EstateProperty;
  productType?: string;
  subscriptionSource?: string;
  subscriptionSourceDetail?: string;
  subscriptionPartner?: string;
  type?: string;
  expenses?: [];
  funds?: [];
  typeTrad?: string;
}

interface RentGains {
  currentMonth?: {
    rent?: number;
    fees?: number;
    totalLoanPaid?: number;
    reduction?: number;
    incomeTax?: number;
    netRent?: number;
    cashFlow?: number;
  };
  currentYear?: {
    rent?: number;
    fees?: number;
    totalLoanPaid?: number;
    reduction?: number;
    incomeTax?: number;
    netRent?: number;
    cashFlow?: number;
  };
  allTime?: {
    rent?: number;
    fees?: number;
    totalLoanPaid?: number;
    reduction?: number;
    incomeTax?: number;
    netRent?: number;
    cashFlow?: number;
  };
  untilDismembership?: {
    rent?: number;
    fees?: number;
    totalLoanPaid?: number;
    reduction?: number;
    incomeTax?: number;
    netRent?: number;
    cashFlow?: number;
  };
}

interface EstateRents {
  amount?: number;
  endDate?: number;
  frequency?: string;
  id?: number;
  isCurrent?: boolean;
  startDate?: number;
  type?: {
    id?: string;
    rental?: boolean;
  };
}

interface EstateLoan {
  id?: number;
  label?: string;
  totalDurationInMonths?: number;
  remainingDurationInMonths?: number;
  borrowedAmount?: number;
  principal?: number;
  color?: string;
}

export interface EstateProperty {
  id?: number;
  areaSize?: number;
  areaSizePrice?: number;
  areaSizeEstimatedPrice?: number;
  type?: string;
  label?: string;
  street?: string;
  street2?: string;
  zipCode?: string;
  city?: string;
  country?: string;
  countryTrad?: string;
}

export class FiscalLaw {
  duration: number = 0;
  startDate;
  endDate;
  id: number = null;
  current: boolean = true;
  leftDuration: number = null;
  priceAmount: number = 0;
  taxeGlobalAmount: number = 0;
  type: string = 'BIC';

  constructor(obj?) {
    this.duration = obj.duration;
    this.endDate = obj.endDate;
    this.startDate = obj.startDate;
    this.id = obj.id;
    this.current = obj.current;
    this.leftDuration = obj.leftDuration;
    this.priceAmount = obj.priceAmount;
    this.taxeGlobalAmount = obj.taxeGlobalAmount;
    this.type = obj.type;
  }
}

export interface EstatePersisted {
  id: number;
  investmentId?: number;
}
